import uniqueId from 'lodash.uniqueid';
// ##### Komarov 2025-07-12
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// ##### Komarov 2025-08-11
import ssrPages from '../../../../server/helpers/ssrPages';
import {
  HomePage,
  MenuPageGenerator,
  NotFound,
  HotelItems,
  GuestItem,
  Register,
  BookingForm,
  OfflineSummary,
  PaymentResult,
  TopToursDetails,
  HotelDetails,
  TourDetailsb,
  CanxBooking,
  RegistrationRotary,
  FORGROUPS,
  Search,
  BodyPage,
  TopHotels,
  UnderSliderText,
  AboutUs
} from '../../../loadable-components';
import { changeLang, getPages } from '../../../Redux/actions';
import LocalizationRoute from '../../Library/Localization/LocalizationRoute';
import LocalizationSwitch from '../../Library/Localization/LocalizationSwitch';

// ##### MultiComponent для рендера нескольких компонентов на одном маршруте
const MultiComponent = ({ components = [], ...rest }) => (
  <>
    {components.map((Component, idx) => (
      <Component key={idx} {...rest} />
    ))}
  </>
);

// ##### Komarov 2025-07-14
const RouteSwitcher = () => {
  const dispatch = useDispatch();

  // ##### Komarov 2025-07-12
  useEffect(() => {
    dispatch(changeLang());
    // ##### 23-04-12 Komarov
  }, [dispatch]);

  // ##### 24-07-25 Komarov
  const lang = useSelector(state => state.language);
  const pagesFromState = useSelector(state => state.pages.pages);
  // ##### 26-07-15 Replaced ContentPages(lang) function call with effect to avoid SSR hook corruption
  useEffect(() => {
    if (!pagesFromState || pagesFromState.length === 0) {
      dispatch(getPages(lang));
    }
  }, [lang, pagesFromState, dispatch]);
  const pages = pagesFromState;

  // ##### 24-03-11 Komarov
  const company_cipher = useSelector(state => state.whitelabel.company_cipher);

  // console.log('SITEPAGES',pages )

  // console.log('LOCALE', locale)
  return (
    <LocalizationSwitch>
      {/* <Switch > */}
      {/* <LocalizationRoute  exact path='/sign_in' component={Login} key={() => uniqueId()}/> */}
      <LocalizationRoute
        exact
        path="/sign_up"
        // ##### Komarov 2025-07-08: TODO: переделать структуру роутов в соответствии с роутами в SSR.
        component={props => (
          <MultiComponent
            components={[Register /*, ДругойКомпонент */]}
            {...props}
          />
        )}
        key={() => uniqueId()}
      />
      <LocalizationRoute
        exact
        path="/payment_result"
        component={PaymentResult}
        key={() => uniqueId()}
      />
      {/* ##### 24-03-11 Komarov */}
      <LocalizationRoute
        exact
        path={`/ref${company_cipher}/payment_result`}
        component={PaymentResult}
        key={() => uniqueId()}
      />
      <LocalizationRoute
        exact
        path="/forgroups"
        component={FORGROUPS}
        key={() => uniqueId()}
      />
      {/* /* <Route  component={NotFound} /> */}
      <LocalizationRoute
        exact
        // Main page
        path="/"
        // component={HomePage}
        // ##### Komarov 2025-07-08: TODO: переделать структуру роутов в соответствии с роутами в SSR.
        component={props => (
          <MultiComponent
            components={[
              HomePage,
              Search,
              BodyPage,
              TopHotels,
              UnderSliderText
            ]}
            {...props}
          />
        )}
        key={() => uniqueId()}
      />
      {/* <Route  exact path='/hotels_in_ukraine' component={SingleHotel}/> */}
      {/* <Route  exact path='/testcities' component={TestCities} />  */}
      {/* <LocalizationRoute  path='/testcities' component={TestCities} /> */}
      {/* <Route  exact path='/search_results' component={GuestItem}/>  */}
      <LocalizationRoute
        exact
        path="/search_results_tours"
        component={GuestItem}
        key={() => uniqueId()}
      />
      {/* ##### 24-03-11 Komarov */}
      <LocalizationRoute
        exact
        path={`/ref${company_cipher}/search_results_tours`}
        component={GuestItem}
        key={() => uniqueId()}
      />
      <LocalizationRoute
        exact
        path="/search_results_hotels"
        component={HotelItems}
        key={() => uniqueId()}
      />
      {/* ##### 24-03-11 Komarov */}
      <LocalizationRoute
        exact
        path={`/ref${company_cipher}/search_results_hotels`}
        component={HotelItems}
        key={() => uniqueId()}
      />
      <LocalizationRoute
        exact
        path="/hotel_details"
        component={HotelDetails}
        key={() => uniqueId()}
      />
      {/* ##### 24-03-11 Komarov */}
      <LocalizationRoute
        exact
        path={`/ref${company_cipher}/hotel_details`}
        component={HotelDetails}
        key={() => uniqueId()}
      />
      <LocalizationRoute
        exact
        path="/tour_details"
        component={TourDetailsb}
        key={() => uniqueId()}
      />
      {/* ##### 24-03-11 Komarov */}
      <LocalizationRoute
        exact
        path={`/ref${company_cipher}/tour_details`}
        component={TourDetailsb}
        key={() => uniqueId()}
      />
      <LocalizationRoute
        exact
        path="/booking_form"
        component={BookingForm}
        key={() => uniqueId()}
      />
      {/* ##### 24-03-11 Komarov */}
      <LocalizationRoute
        exact
        path={`/ref${company_cipher}/booking_form`}
        component={BookingForm}
        key={() => uniqueId()}
      />
      <LocalizationRoute
        exact
        path="/toptours"
        component={TopToursDetails}
        key={() => uniqueId()}
      />
      {/* <LocalizationRoute  exact path='/tophotels' component={TopHotelsDetails} key={() => uniqueId()}/> */}
      <LocalizationRoute
        exact
        path="/offlineSummary"
        component={OfflineSummary}
        key={() => uniqueId()}
      />
      {/* ##### 24-03-11 Komarov */}
      <LocalizationRoute
        exact
        path={`/ref${company_cipher}/offlineSummary`}
        component={OfflineSummary}
        key={() => uniqueId()}
      />
      <LocalizationRoute exact path="/test" component={NotFound} />
      <LocalizationRoute
        exact
        path="/rotaryform"
        component={RegistrationRotary}
        key={() => uniqueId()}
      />
      <LocalizationRoute
        exact
        path="/mybooking"
        component={CanxBooking}
        key={() => uniqueId()}
      />
      {/* ##### 24-08-23 Komarov */}
      <LocalizationRoute
        exact
        path={'/hotel_overview'}
        component={MenuPageGenerator}
        key={() => uniqueId()}
      />
      { /* ##### Komarov 2025-07-24 */}
      <LocalizationRoute
        exact
        path={ssrPages['About Us']}
        component={AboutUs}
        key={() => uniqueId()}
      />
      {/* ##### 24-03-21 Komarov */}
      {/* ##### 24-07-25 Komarov: TODO: убрать из кода фиксированное значение Promocode (refpartner), а, например, при вводе Промокода проверять наличие такого значения Промокода в Смарте, и в случае наличия присылать соотв. картинки и др. данные для страницы этой компании */}
      {/* ##### 24-08-05 Komarov */}
      {/* TODO: Исправить код в соответствии с задачей убрать Промокод из URL */}
      {/* <LocalizationRoute 
        path="/refpartner"
        component={
          (search_data.refpartner === "rot654321" && HeaderWhiteLabel) ||
          HomePage
        }
        key={() => uniqueId()}
      /> */}
      {/* ##### 24-03-11 Komarov */}
      <LocalizationRoute
        exact
        path={`/ref${company_cipher}/sitepages`}
        component={MenuPageGenerator}
        key={() => uniqueId()}
      />
      {/* ##### 24-03-01 Komarov */}

      {
        // ##### 23-09-14 Komarov
        //   pages&&pages.map((page)=>{
        // ##### 24-03-21 Komarov
        Object.values(pages)?.map(page => {
          if (parseInt(page.id) === 198) {
            // ##### 24-03-21 Komarov
            return (
              <LocalizationRoute
                exact
                path={'/profile'}
                component={MenuPageGenerator}
                key={() => uniqueId()}
              />
            );
          }
          // ##### 24-03-21 Komarov
          if (
            page.sitepage_type_name &&
            ['ATTRACTIONS' /* , "CITIES" */].indexOf(page.sitepage_type_name) >
            -1
          ) {
            // ##### 24-03-21 Komarov
            return (
              <LocalizationRoute
                exact
                path={'/city_overview'}
                component={MenuPageGenerator}
                key={() => uniqueId()}
              />
            );
          }
          return (
            // ##### 24-03-21 Komarov
            <LocalizationRoute
              exact
              path={'/sitepages'}
              component={MenuPageGenerator}
              key={() => uniqueId()}
            />
          );
        })
      }
    </LocalizationSwitch>
  );
};

export default RouteSwitcher;
